// Captura o evento de instalação do app (PWA) o mais cedo possível.
// O navegador dispara "beforeinstallprompt" uma única vez, normalmente antes
// das telas montarem — por isso guardamos aqui e as telas apenas consultam.

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

export const isStandalone = () =>
    (typeof window !== 'undefined' &&
        (window.matchMedia?.('(display-mode: standalone)').matches ||
            window.navigator.standalone === true));

export const isIOS = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return /iPhone|iPad|iPod/i.test(ua) || iPadOS;
};

if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        // impede o mini-banner automático: a instalação passa a ser pelo nosso botão
        e.preventDefault();
        deferredPrompt = e;
        notify();
    });

    window.addEventListener('appinstalled', () => {
        deferredPrompt = null;
        notify();
    });
}

export const getInstallState = () => ({
    canPrompt: !!deferredPrompt,
    installed: isStandalone(),
    ios: isIOS(),
});

export const subscribeInstall = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

export const promptInstall = async () => {
    if (!deferredPrompt) return 'unavailable';
    const evt = deferredPrompt;
    evt.prompt();
    const { outcome } = await evt.userChoice;
    // o mesmo evento não pode ser reutilizado
    deferredPrompt = null;
    notify();
    return outcome; // 'accepted' | 'dismissed'
};
